import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './Feedback.css';

interface FeedbackProps {}

export const Feedback: React.FC<FeedbackProps> = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Feedback
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          We value your input! Please use the form below to share your thoughts, suggestions, or report any issues.
        </Typography>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <div className="asana-embed-container">
            <link rel="stylesheet" href="https://form.asana.com/static/asana-form-embed-style.css"/>
            <iframe 
              className="asana-embed-iframe" 
              height="1200" 
              width="800" 
              src="https://form.asana.com/?k=tHxh81qeyOt9t_HT7kgJEA&d=225528942472664&embed=true"
              title="Feedback Form"
              style={{ border: 'none', borderRadius: theme.shape.borderRadius }}
            />
            <div className="asana-embed-footer">
              <a 
                rel="nofollow noopener" 
                target="_blank" 
                className="asana-embed-footer-link" 
                href="https://asana.com/?utm_source=embedded_form"
              >
                <span className="asana-embed-footer-text">Form powered by</span>
                <div className="asana-embed-footer-logo" role="img" aria-label="Logo of Asana"></div>
              </a>
            </div>
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

export default Feedback;
